module.exports = __webpack_public_path__ + "img/short_variable_declaration.ada142f1.png";